import { useSession } from 'Src/hooks/useSession';

interface AuthenticationRequiredProps {
  children: React.ReactNode;
}

export default function AuthenticationRequired({ children }: AuthenticationRequiredProps) {
  const { session } = useSession();
  if (!session) return null;

  return children;
}
